import { render, staticRenderFns } from "./timeline-follow-up.vue?vue&type=template&id=b807b428"
import script from "./timeline-follow-up.vue?vue&type=script&lang=js"
export * from "./timeline-follow-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports